module.exports = __webpack_public_path__ + "static/media/280824.6cca778d.png";